import React, { useState, useRef, useEffect } from 'react';
import './ButtonIconContextMenu.css';

const ButtonIconContextMenu = ({
    children,
    menuItems = [{ label: 'Cancella', onClick: () => {} }],
    ariaLabel = 'Menu options'
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const refContainer = useRef(null);

    const toggleDropdown = () => {
        setShowDropdown(prev => !prev);
    };

    const handleMenuItemClick = (onClick) => {
        setShowDropdown(false);
        onClick();
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            toggleDropdown();
        }
    };

    useEffect(() => {
        if (!showDropdown) return;

        const handleClickOutside = (e) => {
            if (refContainer.current && !refContainer.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };

        const handleEscKey = (e) => {
            if (e.keyCode === 27) {
                e.stopPropagation();
                setShowDropdown(false);
            }
        };

        window.addEventListener('click', handleClickOutside);
        window.addEventListener('keydown', handleEscKey, false);

        return () => {
            window.removeEventListener('click', handleClickOutside);
            window.removeEventListener('keydown', handleEscKey, false);
        };
    }, [showDropdown]);

    return (
        <div className="buttonIconContextMenu" ref={refContainer}>
            <button
                className="button-icon"
                type="button"
                onClick={toggleDropdown}
                onKeyDown={handleKeyDown}
                aria-expanded={showDropdown}
                aria-haspopup="true"
                aria-label={ariaLabel}
            >
                {children}
            </button>

            {showDropdown && (
                <div className="buttonIconContextMenu__dropdown">
                    <ul className="buttonIconContextMenu__menu">
                        {menuItems.map((item, index) => (
                            <li key={index}>
                                <button
                                    className="buttonIconContextMenu__menuItem"
                                    onClick={() => handleMenuItemClick(item.onClick)}
                                    type="button"
                                >
                                    {item.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default ButtonIconContextMenu;
